import { DEV_MODE } from '@/config/dev-mode'
import { createQueryString, filterParams } from '@/utils/queryUtils'
import { clarify } from '@/utils/clear'
import axios from 'axios'
const endpoint = import.meta.env.VITE_APP_GW_URL
const systemId = import.meta.env.VITE_APP_SYSTEMID

/** 댓글 받아오기 */
export async function getComments(articleId, COMMENT_TYPE, params = undefined) {
  try {
    const path = `/comment/${articleId}/${COMMENT_TYPE}`
    let query = params && typeof params === 'object' ? { ...params } : undefined
    if (query && Object.prototype.hasOwnProperty.call(query, 'Page')) {
      query.page = query.Page
      delete query.Page
    }
    const response = await axios.get(path, query ? { params: query } : undefined)
    return response.data
  } catch (error) {
    console.error('getComments메서드 데이터 받지 못함:', error)
    return []
  }
}

/** 댓글 등록하기 */
export async function saveComment(articleId, params) {
  try {
    const url = `/comment/${articleId}/save`
    const response = await axios.post(url, params)
    return response.data
  } catch (error) {
    DEV_MODE && console.error('saveComment 중 에러:', error)
  }
}

/** 댓글 수정하기 */
export async function editComment(articleId, params) {
  try {
    const url = `/comment/${articleId}/save`
    const response = await axios.put(url, params)
    return response.data
  } catch (error) {
    DEV_MODE && console.error('editComment 중 에러:', error)
  }
}

/** 댓글 삭제하기 */
export async function delComment(commentId) {
  try {
    const url = `/comment/${commentId}/delete`
    const response = await axios.delete(url)
    return response
  } catch (error) {
    DEV_MODE && console.error('editComment 중 에러:', error)
  }
}

/** 댓글 좋아요 등록 및 삭제 */
export const patchCommentLike = async (commentId) => {
  const params = new URLSearchParams(
    clarify({
      likeType: 'COMMENT',
      commentId,
    }),
  )
  const response = await axios.patch(`${endpoint}/like/${commentId}`, null, { params })
  return response.data
}

/** 댓글별 좋아요 갯수 및 클릭 여부 */
export const checkLikeComment = async (commentId) => {
  try {
    const url = `/like/checkLike/${systemId}/COMMENT/count/infos`
    const response = await axios.get(`${endpoint}${url}?ids=${commentId}`)
    return response
  } catch (error) {
    DEV_MODE && console.error('checkLikeComment 중 에러:', error)
  }
}

/** 댓글 갯수 조회 */
export const getCommentCount = async (articleId, commentType) => {
  const response = await axios.get(
    `/comment/systems/${systemId}/articles/${articleId}/type/${commentType}`,
  )
  return response.data
}
